import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import en from './locales/en.json';
import hi from './locales/hi.json';
import ja from './locales/ja.json';
import zh from './locales/zh.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import ar from './locales/ar.json';
import ko from './locales/ko.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import it from './locales/it.json';

const resources = {
  en: { translation: en },
  'en-IN': { translation: en },
  'en-US': { translation: en },
  'en-GB': { translation: en },
  'en-CA': { translation: en },
  'en-AU': { translation: en },
  'en-SG': { translation: en },
  'en-MY': { translation: en },
  'en-TH': { translation: en },
  'en-ZA': { translation: en },
  'en-AE': { translation: en },
  hi: { translation: hi },
  ja: { translation: ja },
  zh: { translation: zh },
  es: { translation: es },
  'es-MX': { translation: es },
  fr: { translation: fr },
  'fr-CA': { translation: fr },
  de: { translation: de },
  ar: { translation: ar },
  'ar-SA': { translation: ar },
  ko: { translation: ko },
  pt: { translation: pt },
  'pt-BR': { translation: pt },
  ru: { translation: ru },
  it: { translation: it },
  nl: { translation: en }, // Dutch - fallback to English
  id: { translation: en }, // Indonesian - fallback to English
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
